import { createControlComponent } from '@react-leaflet/core'
import { Control, Map } from 'leaflet'
import { renderToStaticMarkup } from 'react-dom/server'
import styled from 'styled-components'
import PlusIcon from '@foros-fe/assets/icons/plus.svg'
import MinusIcon from '@foros-fe/assets/icons/minus.svg'
import { theme } from '../../../config'

const Separator = styled.div`
  width: 24px;
  height: 1px;
  background-color: ${theme.colors.gray[400]};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const ZoomControl = createControlComponent<Control.Zoom, Control.ZoomOptions>((props) => {
  const instance = Control.Zoom.extend({
    onAdd(map: Map) {
      const element = Control.Zoom.prototype.onAdd!.call(this, map)

      element.insertAdjacentHTML('beforeend', renderToStaticMarkup(<Separator />))

      return element
    },
  })

  return new instance({
    position: 'topright',
    zoomInText: renderToStaticMarkup(<PlusIcon width={16} height={16} />),
    zoomOutText: renderToStaticMarkup(<MinusIcon width={16} height={2} />),
    ...props,
  })
})
